import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { AuthModel, UserModel } from '../../models/auth.model';

interface ChangePasswordPayload {
  user_id: number | null;
  current_password: string;
  new_password: string;
  password_confirmation: string;
}

const API_USERS_URL = `${environment.apiUrl}`;

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  token: string;
  role: string;
  is_accept: boolean;

  constructor(private http: HttpClient) { }

  // public methods
  login(username: string, password: string): Observable<any> {
    return this.http.post<AuthModel>(`${API_USERS_URL}/user_logins/login`, { username, password }).pipe(tap((resp) => {
      if (resp.success) {
        this.setToken(resp);
        this.setUser(resp.session.user);
        this.setRole(resp);
        this.setisAccept(resp);
      }
    }));
  }

  changePassword(user_id: number | null, current_password: string, new_password: string, password_confirmation: string): Observable<any> {
    const payload: ChangePasswordPayload = { user_id, current_password, new_password, password_confirmation };
    return this.http.post(`${API_USERS_URL}/user_logins/change_password`, payload);
  }

  setToken(resp: AuthModel) {
    this.token = resp.session.access_token;
    localStorage.setItem("access_token", this.token);
  }

  setUser(resp: UserModel) {
    localStorage.setItem("user", JSON.stringify(resp));
  }

  setRole(resp: AuthModel) {
    this.role = resp.session.role_id;
    localStorage.setItem("role", this.role.toString());
  }

  setisAccept(resp: AuthModel) {
    this.is_accept = resp.session.is_accept;
    localStorage.setItem("is_accept", this.is_accept.toString());
  }

  // CREATE =>  POST: add a new user to the server
  createUser(user: UserModel): Observable<UserModel> {
    return this.http.post<UserModel>(API_USERS_URL, user);
  }

  // Your server should check email => If email exists send link to the user and return true | If email doesn't exist return false
  forgotPassword(email: string): Observable<boolean> {
    return this.http.post<boolean>(`${API_USERS_URL}/forgot-password`, {
      email,
    });
  }

  getUserByToken(token: string): Observable<UserModel> {
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get<UserModel>(`${API_USERS_URL}/me`, {
      headers: httpHeaders,
    });
  }
}
